<!-- eslint-disable vue/valid-v-else -->
<template>
  <div
    class="product-description product-description-leaflet mb-8"
    v-if="tabs.length > 0"
  >
    <v-container class="pa-0">
      <v-expansion-panels accordion flat tile v-model="panel">
        <v-expansion-panel
          v-for="tab in tabs"
          :key="tab.title"
          :class="tab.cssClass"
          class="my-1 product-description-border"
          :aria-controls="'panel-content-' + tab.title"
          role="button"
        >
          <v-expansion-panel-header
            class="pa-0 px-sm-3 product-description-title-container secondary lighten-1"
            :aria-controls="'panel-content-' + tab.title"
            role="button"
            :aria-expanded="panel.includes(tab.title) ? 'true' : 'false'"
          >
            <template v-slot:actions>
              <v-icon small>mdi-chevron-down</v-icon>
            </template>
            <div
              class="text-body-1 font-weight-bold secondary--text px-4"
              v-html="tab.title"
            />
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mt-2">
            <div
              v-for="item in tab.items"
              :key="item.title"
              class="product-description-metadata pb-4"
              :class="item.cssClass"
            >
              <v-col cols="12" class="pa-0">
                <h4
                  v-if="item.title"
                  class="mb-1 description-header font-weight-semibold"
                >
                  {{ item.title }}
                </h4>
              </v-col>
              <div
                v-for="path in item.paths"
                :key="path.key"
                class="description-content"
              >
                <v-col cols="12" class="pa-0">
                  <component
                    :is="path.template || 'DefaultTpl'"
                    :content="path.content"
                    :append="path.append"
                /></v-col>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>
<style lang="scss">
.product-description-leaflet {
  .product-description-title-container {
    .mdi-chevron-down {
      font-size: 24px !important;
    }
    .v-expansion-panel-header__icon {
      width: 10%;
    }
  }

  .description-header,
  table tbody tr th {
    color: var(--v-grey-darken1) !important;
  }
  .product-description-border {
    flex-direction: column !important;
    height: auto !important;
    min-height: auto !important;
    overflow: inherit !important;
  }
  .product-description-metadata {
    // .description-content {
    //   table,
    //   tbody {
    //     display: flex;
    //     flex-direction: row;
    //     th {
    //     }
    //   }
    // }
    .product-description {
      @media #{map-get($display-breakpoints, 'xs-only')} {
        h3 {
          font-weight: normal;
        }
        .v-expansion-panel--active > .v-expansion-panel-header {
          min-height: 48px;
        }
        .v-expansion-panel {
          margin-bottom: 1px;
        }
      }
      .v-tabs {
        border-bottom: none;
      }
      .v-tabs-bar {
        background-color: transparent !important;
        height: 57px;
      }
      .v-tabs-items {
        background: transparent !important;
        padding: 10px;
        border-top: none;
        letter-spacing: 0px;
      }
      .v-tab {
        color: $secondary !important;
        background-color: rgba(24, 152, 139, 0.1) !important;
        margin: 0px 5px 0px 0px;
        text-transform: initial;
        font-size: 18px;
        letter-spacing: 0px;
      }
      .v-tabs-slider-wrapper {
        color: transparent !important;
      }
      .v-tab--active {
        // border-bottom: 5px solid;
        color: #18988b !important;
        background-color: rgba(24, 152, 139, 0.3) !important;
      }
      // @media #{map-get($display-breakpoints, 'xs-only')} {
      //   .v-expansion-panel-content__wrap {
      //     font-size: 11px;
      //   }
      // }
    }
  }
}
</style>
<script>
import get from "lodash/get";
import tabsConfig from "/public/product/descriptionTabsConfig.json";
import kebabCase from "lodash/kebabCase";
import {
  DefaultTpl,
  LabelsTpl,
  ItemsMapTpl,
  TableTpl,
  NameAndValueTpl,
  ValueTpl,
  WarningsTpl,
  ListTpl
} from "@/components/product/templates";
export default {
  name: "ProductDescriptionLeaflet",
  /* eslint-disable vue/no-unused-components */
  components: {
    DefaultTpl,
    LabelsTpl,
    ItemsMapTpl,
    TableTpl,
    NameAndValueTpl,
    ValueTpl,
    WarningsTpl,
    ListTpl
  },
  data() {
    return {
      selectedTab: null,
      productDescriptionTabs: tabsConfig,
      panel: []
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    productMetadata: {
      type: Object
    },
    ingredientList: {
      type: Object
    }
  },
  computed: {
    tabs() {
      let tabs = [];
      this.productDescriptionTabs.forEach(tabMeta => {
        let items = [];
        tabMeta.items.forEach(parMeta => {
          let paths = [];
          parMeta.paths.forEach(pathMeta => {
            let content = get(this.product, pathMeta.data || pathMeta);
            let append = pathMeta.append;
            // check if content is empty
            if (content && content !== "<p></p>") {
              // check if table has empty cells
              if (pathMeta.template === "TableTpl") {
                let cells = JSON.parse(content).cells;
                let hasContent = cells.find(c => {
                  return c !== null;
                });
                if (!hasContent) {
                  return;
                }
              }
              if (pathMeta.template === "ValueTpl") {
                let value = JSON.parse(content).value;
                if (!value) {
                  return;
                }
              }
              paths.push({
                key: pathMeta.data || pathMeta,
                content: content,
                template: pathMeta.template,
                append: append
              });
            }
          });
          if (paths.length > 0) {
            items.push({
              title: parMeta.title,
              paths: paths,
              cssClass: get(parMeta, "cssClass", kebabCase(parMeta.title))
            });
          }
        });
        if (items.length > 0) {
          tabs.push({
            title: tabMeta.title,
            items: items,
            cssClass: get(tabMeta, "cssClass", kebabCase(tabMeta.title))
          });
        }
      });

      // additional text at Ingredients tab end
      // let ingredientsTab = tabs.find(t => {
      //   return t.title === "Ingredienti e valori nutrizionali";
      // });
      // if (ingredientsTab) {
      //   ingredientsTab.items.push({
      //     paths: [
      //       { content: this.$t("productDescription.ingredientsAdditionalInfo") }
      //     ]
      //   });
      // }
      return tabs;
    }
  }
};
</script>
